import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

export const ImageOverlaySchema = ({ schema, intl }) => {
  addStyling({ schema, intl });

  // Add your custom variant field
  schema.properties.styles.schema.properties.image_overlay = {
    widget: 'select',
    title: 'Image Overlay',
    choices: [
      ['transparent', 'Transparent'],
      ['gradient-primary', 'Gradient Primary'],
    ],
    default: 'transparent',
  };
  schema.properties.styles.schema.fieldsets[0].fields.push('image_overlay');

  return schema;
};
